import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight: '90vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid grey-400',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  fontFamily: 'Arial, sans-serif',

};

export default function SharedPopupModal(
  {ChildComponent,
   open,
   handleClose,
   popupModalProps}) {

const {
  fetchData,
  handleFetchFailure,
  handleFetchSuccess,
  formData,
  setReportPeriod,
  reportPeriod} = popupModalProps
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          
          <ChildComponent 
          reportPeriod={reportPeriod} 
          setReportPeriod={setReportPeriod} 
          formData = {formData} 
          fetchData = {fetchData} 
          handleClose = {handleClose} 
          handleFetchSuccess={handleFetchSuccess} 
          handleFetchFailure={handleFetchFailure} />
          {/* <ChildComponent  {...popupModalProps} /> */}
        </Box>
      </Modal>
    </div>
  );
}
